'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box, { BoxProps } from '../../../box'

/* -----------------------------------------------------------------------------
 * CheckBoxElement
 * -------------------------------------------------------------------------- */

export type CheckBoxElementProps = Pick<
  React.ComponentProps<'input'>,
  'disabled'
> &
  BoxProps & {
    onValueChange?: (value: boolean) => void
    value?: boolean
  }

const CheckBoxElement = ({ value, ...rest }: CheckBoxElementProps) => {
  return (
    <Box {...rest}>
      <input
        type='checkbox'
        checked={value}
        readOnly
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          background: 'transparent',
          border: 'none',
          boxShadow: 'none',
          opacity: 0,
          padding: 0,
          margin: 0,
          flex: '1 1 auto',
          width: '100%',
          height: '100%'
        }}
      />
    </Box>
  )
}

export default CheckBoxElement
